import Media from './Media'

export default Media



// WEBPACK FOOTER //
// ./src/components/Media/index.js